<template>
	<div id="sidebar">
		<el-menu
			default-active="0-1"
			class="el-menu-vertical-demo"
			:collapse="open"
			@open="item"
			@close="item"
			active-text-color="#00BCD4"
		>
			<button-collapse-sidebar :open="open" @change="$emit('change')" />

			<el-submenu index="0" :class="{ selected: activeIndex[0] }">
				<template slot="title">
					<i class="el-icon-document" :class="{ color: activeIndex[0] }"></i>
					<span slot="title">File</span>
				</template>
				<el-menu-item-group :class="{ opened: activeIndex[0] }">
					<span slot="title">Group One</span>
					<el-menu-item index="0-1" @click="workspace">Workspace</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-submenu index="1" :class="{ selected: activeIndex[1] }">
				<template slot="title">
					<i class="el-icon-plus" :class="{ color: activeIndex[1] }"></i>
					<span slot="title">Aggiungi</span>
				</template>
				<el-menu-item-group :class="{ opened: activeIndex[1] }">
					<span slot="title">Group One</span>
					<el-menu-item index="1-1">item one</el-menu-item>
					<el-menu-item index="1-2">item two</el-menu-item>
				</el-menu-item-group>
				<el-menu-item-group title="Group Two" :class="{ opened: activeIndex[1] }">
					<el-menu-item index="1-3">item three</el-menu-item>
				</el-menu-item-group>
				<el-submenu index="1-4">
					<span slot="title">item four</span>
					<el-menu-item index="1-4-1">item one</el-menu-item>
				</el-submenu>
			</el-submenu>

			<el-menu-item index="2" :class="{ selected: activeIndex[2] }">
				<i class="el-icon-share" :class="{ color: activeIndex[2] }"></i>
				<span slot="title">Condividi</span>
			</el-menu-item>

			<el-submenu index="3" :class="{ selected: activeIndex[3] }">
				<template slot="title">
					<i class="el-icon-user-solid" :class="{ color: activeIndex[3] }"></i>
					<span slot="title">I tuoi clienti</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="3-1" :class="{ opened: activeIndex[3] }" @click="clients"
						>Visualizza</el-menu-item
					>
					<el-menu-item index="3-2" :class="{ opened: activeIndex[3] }">Inserisci</el-menu-item>
					<el-menu-item index="3-3" :class="{ opened: activeIndex[3] }">Condividi</el-menu-item>
				</el-menu-item-group>
			</el-submenu>

			<el-menu-item index="4">
				<i class="el-icon-setting"></i>
				<span slot="title">Impostazioni</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
import ButtonCollapseSidebar from "../../_common/button/button-collapse-sidebar.vue"
export default {
	name: "CloudSidebar",
	props: ["open", "change"],
	components: {
		"button-collapse-sidebar": ButtonCollapseSidebar
	},
	data() {
		return {
			activeIndex: {
				0: false,
				1: false,
				2: false,
				3: false,
				4: false
			},
			currentRoute: ""
		}
	},
	created() {
		this.activeIndex[0] = true
	},
	methods: {
		item: function (key) {
			this.activeIndex[key] = !this.activeIndex[key]
		},

		clients: function () {
			this.$router.push({ path: "/cloud/clients" })
			this.currentRoute = "clients"
		},
		workspace: function () {
			if (this.disabled) return
			this.$router.push({ path: "/cloud/" })
			this.currentRoute = "workspace"
		},

		disabled: function () {
			if (this.$route.path == "/" + this.currentRoute) return true
			return false
		}
	}
}
</script>

<style scoped lang="scss">
.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 200px;
}
#sidebar {
	position: absolute;
	left: 1px;
	top: 62px;
	border-top: 3px solid #00bcd4;
}
.icon {
	display: flex;
	z-index: 2;
	position: absolute;
	right: -8px;
	top: 0;
	width: 20px;
	height: 20px;
	border-radius: 25px;
	background-color: white;
	&:hover {
		cursor: pointer;
	}
}
.expand {
	transform: rotate(180deg);
	-webkit-transform: rotate(180deg);
}

.opened {
	border-left: 3px solid #00bcd4;
}
.selected {
	background-color: rgba(0, 188, 212, 0.3);
}
.el-menu-item:hover {
	background-color: rgba(0, 188, 212, 0.1);
}
</style>
